var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vm-pagination"},[_c('el-pagination',{attrs:{"background":"","layout":"prev, pager, next, sizes","current-page":_vm.queryInfo.pageNum,"page-size":_vm.queryInfo.pageSize,"page-sizes":[10, 50, 100],"total":_vm.queryInfo.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }